<template>
  <div id="app">
    <img alt="Vue logo" src="./assets/logo.png" class="logo">
    <h1>VueJS project for SalesForce</h1>
    
    <div v-if="employeesData.length">
      <h2>Employees list</h2>
      <button @click="sendData">Send data back</button>
      <table>
        <thead>
          <tr>
            <th>index</th>
            <th>age</th>
            <th>eyeColor</th>
            <th>name</th>
            <th>gender</th>
            <th>company</th>
            <th>email</th>
            <th>phone</th>
            <th>salary</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in employeesData" :key="row.index">
            <td>{{row.index}}</td>
            <td>{{row.age}}</td>
            <td>{{row.eyeColor}}</td>
            <td>{{row.name}}</td>
            <td>{{row.gender}}</td>
            <td>{{row.company}}</td>
            <td>{{row.email}}</td>
            <td>{{row.phone}}</td>
            <td><input type="number" v-model="row.salary"></td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>

export default {
  name: 'App',
  data: function () {
    return {
      employeesData: []
    }
  },
  computed: {
    employeesDataHeaders () {
      const firstRow = this.employeesData.length ? this.employeesData[0] : {};
      return Object.keys(firstRow);
    }
  },
  methods: {
    sendData () {
      const parentWindow = window.parent;
				
      const message = {
        type: "employees-list",
        data: this.employeesData
      };
      
      parentWindow.postMessage(message, "*");
    }
  },
  mounted () {
    window.addEventListener("message", (e) => {

      let data = e.data ? e.data : {};
      let type = data.type;
      var content = data.data;
      
      if(type === "employees-list") {
        this.employeesData = JSON.parse(content);
      }

    });
  }
}
</script>

<style>
body {
  background: #fff;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 10px;
}

table {
  width: 100%;
  max-width: 1200px;
  margin: 20px auto;
}

button {
    padding: 10px;
    background: #07ab85;
    color: #fff;
    font-weight: bold;
    border: none;
    text-transform: uppercase;
    border-radius: 5px;
}

.logo {
  max-width: 100px;
}
</style>
